<template>
  <div class="container-fluid mt-5">
    <loading
      :active.sync="fullscreenLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
    ></loading>
    <div class="row">
      <div class="col-12 text-right">
        <base-button
          @click="goBack"
          type="button"
          class="btn btn-sm btn-primary"
          >Volver</base-button
        >
      </div>
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Editar usuario</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                type="button"
                class="btn btn-sm btn-primary"
                @click="addTipo()"
                >Enviar mensaje</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form ref="profile_form" @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-lg-3">
                  <div v-if="image" class="profile-image card-img">
                    <img :src="`${image}`" class="profile-image argon-image" />
                  </div>
                  <div v-else class="profile-image">
                    <img
                      src="/img/placeholder.png"
                      class="argon-image"
                      width="212"
                    />
                  </div>
                  <div class="image-upload">
                    <base-button
                      v-if="image"
                      type="button"
                      class="btn btn-sm btn-danger"
                      @click="removeImage"
                    >
                      <span>
                        <i class="fa fa-times" />
                        Eliminar
                      </span>
                    </base-button>
                    <base-button type="button" class="btn btn-sm btn-primary">
                      <label v-if="!image" for="imageInput" class="mb-0"
                        >Seleccionar imagen</label
                      >
                      <label v-else for="imageInput" class="mb-0"
                        >Cambiar</label
                      >
                      <input
                        id="imageInput"
                        ref="imageInput"
                        accept="image/*"
                        type="file"
                        style="display: none"
                        @change="onSelectFile"
                      />
                    </base-button>
                  </div>
                </div>
                <div class="col-lg-9">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Nombre"
                        placeholder="Nombre"
                        v-model="user.nombre"
                      />
                      <validation-error :errors="apiValidationErrors.nombre" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Apellidos"
                        placeholder="Apellidos"
                        v-model="user.apellidos"
                      />
                      <validation-error
                        :errors="apiValidationErrors.apellidos"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                        label="Email"
                        placeholder="Email"
                        v-model="user.email"
                      />
                      <validation-error :errors="apiValidationErrors.email" />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Teléfono"
                        placeholder="Teléfono"
                        v-model="user.telefono"
                      />
                      <validation-error
                        :errors="apiValidationErrors.telefono"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="my-2 text-right">
                <base-button
                  type="button"
                  class="btn btn-sm btn-primary"
                  native-type="submit"
                >
                  Actualizar usuario
                </base-button>
              </div>
            </form>
          </div>
        </card>

        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Equipos asignados</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                size="sm"
                type="button"
                class="btn-primary"
                @click="desAssignPost()"
                v-if="multipleSelection.length > 0"
              >
                Devolver equipos
              </base-button>
            </div>
          </div>

          <div class="card-body p-0">
            <div class="p-0">
              <div
                class="row col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <!-- BUSCADOR:-->
                <div class="col-md-4">
                  <div>
                    <form>
                      <base-input
                        v-model="query"
                        type="search"
                        prepend-icon="fas fa-search"
                        placeholder="Buscar por marca, modelo, nº serie, usuario..."
                        clearable
                      />
                    </form>
                  </div>
                </div>
                <!-- FILTROS:-->
                <div class="col-md-8">
                  <div
                    class="d-flex justify-content-right justify-content-sm-end"
                  >
                    <div class="pr-4">
                      <el-select
                        class="select-primary pagination-select"
                        v-model="estado"
                        placeholder="Estado"
                        style="width: 100%; height: 46px !important"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in estados"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div>
                      <div class="row">
                        <div class="col pr-1">
                          <base-input label="">
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="configInput"
                              class="form-control datepicker"
                              v-model="fdesde"
                              placeholder="Prox. revisión desde..."
                            >
                            </flat-picker>
                          </base-input>
                        </div>
                        <div class="col pl-0">
                          <base-input label="">
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="configInput"
                              class="form-control datepicker"
                              v-model="fhasta"
                              placeholder="Prox. revisión hasta..."
                            >
                            </flat-picker>
                          </base-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- TABLA DE EQUIPOS:-->
              <el-table
                ref="multipleTable"
                class="table-responsive align-items-center table-flush"
                header-row-class-name="thead-light"
                :data="activos"
                @sort-change="sortChange"
                @selection-change="handleSelectionChange"
                empty-text="No hay ningún elemento en esta tabla"
              >
                <!-- LOADING-->
                <div slot="empty" v-if="loadingTable">
                  <img
                    src="/img/loading.gif"
                    style="height: 100px; width: 100px"
                  />
                </div>
                <el-table-column type="selection" width="30"> </el-table-column>
                <!--  <el-table-column
                  label="CATEGORIA"
                  prop="subtipo.data.attributes.nombre"
                  sortable="custom"
                  :min-width="60"
                /> -->
                <!--   <el-table-column
                  label="SUBTIPO"
                  prop="modelo.data.attributes.subtipo.data.attributes.nombre"
                  sortable="custom"
                  :min-width="100"
                >
                </el-table-column> -->

                <!--  <el-table-column
                  label="Marca"
                  prop="fabricante.data.attributes.nombre"
                  sortable="custom"
                  :min-width="60"
                /> -->

                <el-table-column
                  label="Modelo"
                  prop="modelo.data.attributes.nombre"
                  sortable="custom"
                  :min-width="100"
                >
                  <template v-slot="{ row }">
                    {{ row.modelo.data.attributes.nombre + "-" }}
                    <b>{{ row.fabricante.data.attributes.nombre }}</b>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Nº serie"
                  prop="numero_serie"
                  sortable="custom"
                  :min-width="50"
                >
                  <template v-slot="{ row }">
                    <b>{{ row.numero_serie }}</b>
                  </template>
                </el-table-column>

                <el-table-column
                  label=""
                  :min-width="24"
                  justify-content-center
                >
                  <template v-slot="{ row }">
                    <!-- RETIRADO -->
                    <div v-if="row.retirado" class="retired-icon">
                      <i
                        class="fas fa-archive"
                        style="color: #666; font-size: 18px"
                      ></i>
                      <span class="badge badge-retired no-strike"
                        >RETIRADO</span
                      >
                    </div>
                    <!-- NO APTO -->
                    <img
                      v-else-if="
                        row.revisiones.data.length > 0 &&
                        row.revisiones.data[row.revisiones.data.length - 1]
                          .attributes.estado === 'no_apto'
                      "
                      src="/img/ios-alert.png"
                      style="height: 24px; width: 24px"
                    />
                    <!-- CADUCADOS -->
                    <img
                      v-else-if="
                        moment(row.fecha_prox_revision).isBefore(
                          new Date().getTime()
                        )
                      "
                      src="/img/ios-time.png"
                      style="height: 24px; width: 24px"
                    />
                    <!--  APTO A VIGILAR -->
                    <img
                      v-else-if="
                        row.revisiones.data.length > 0 &&
                        row.revisiones.data[row.revisiones.data.length - 1]
                          .attributes.estado === 'apto_a_vigilar'
                      "
                      src="/img/ios-checkmark-orange.png"
                      style="height: 24px; width: 24px"
                    />

                    <img
                      v-else-if="
                        moment()
                          .add(3, 'months')
                          .isSameOrAfter(moment(row.fecha_prox_revision))
                      "
                      src="/img/ios-time-blue.png"
                      style="height: 24px; width: 24px"
                    />

                    <img
                      v-else-if="
                        row.revisiones.data.length > 0 &&
                        row.revisiones.data[row.revisiones.data.length - 1]
                          .attributes.estado === 'apto'
                      "
                      src="/img/ios-checkmark-circle.png"
                      style="height: 24px; width: 24px"
                    />
                    <img
                      v-else-if="
                        moment()
                          .add(3, 'months')
                          .isBefore(moment(row.fecha_prox_revision))
                      "
                      src="/img/ios-checkmark-circle.png"
                      style="height: 24px; width: 24px"
                    />

                    <!--       <img
                    v-else-if="
                      moment(row.fecha_prox_revision).isSameOrAfter(
                        new Date().getTime()
                      )
                    "
                    src="/img/ios-checkmark-circle.png"
                    style="height: 24px; width: 24px"
                  /> -->

                    <!--     incidencias: {
                estado_incidencia: {
                  descripcion: { $eq: "abierta" },
                },
              }, -->
                  </template>
                </el-table-column>

                <!--   <el-table-column
                  label="Prox. Revisión"
                  prop="fecha_prox_revision"
                  sortable="custom"
                  :min-width="130"
                >
                  <template slot-scope="{ row }">
                    <badge class="badge-dot mr-4" type="">
                      <i
                        v-if="
                          moment(row.fecha_prox_revision).isSameOrAfter(
                            new Date().getTime()
                          )
                        "
                        class="`bg-success`"
                      ></i>
                      <i
                        v-if="
                          moment(row.fecha_prox_revision).isBefore(
                            new Date().getTime()
                          )
                        "
                        class="`bg-warning`"
                      ></i>
                      <span class="status"
                        >{{
                          moment(row.fecha_prox_revision).format("DD/MM/YYYY")
                        }}
                        ({{ moment(row.fecha_prox_revision).fromNow() }})</span
                      >
                    </badge>
                  </template>
                </el-table-column> -->

                <el-table-column
                  label="Prox. Revisión"
                  prop="fecha_prox_revision"
                  sortable="custom"
                  :min-width="100"
                >
                  <template v-slot="{ row }">
                    <badge class="badge-dot mr-4" type="">
                      <i
                        v-if="
                          moment(row.fecha_prox_revision).isBefore(
                            new Date().getTime()
                          )
                        "
                        class="bg-danger"
                      ></i>
                      <i
                        v-else-if="
                          moment()
                            .add(3, 'months')
                            .isSameOrAfter(moment(row.fecha_prox_revision))
                        "
                        class="bg-warning"
                      ></i>
                      <i
                        v-else-if="
                          moment(row.fecha_prox_revision).isSameOrAfter(
                            new Date().getTime()
                          )
                        "
                        class="bg-success"
                      ></i>

                      <span class="status"
                        >{{
                          moment(row.fecha_prox_revision).format("DD/MM/YYYY")
                        }}
                        ({{ moment(row.fecha_prox_revision).fromNow() }})</span
                      >
                    </badge>
                  </template>
                </el-table-column>

                <!-- <el-table-column
                  label="Planta"
                  prop="empresa.data.attributes.alias"
                  sortable="custom"
                  :min-width="90"
                /> -->

                <!--  <el-table-column
                  label="Usuario"
                  sortable="custom"
                  :min-width="100"
                >
                  <template v-slot="{ row }">
                    <a
                      v-if="row.usuario.data"
                      :href="
                        '/user-management/edit-user/' + row.usuario.data.id
                      "
                      class="font-weight-bold"
                    >
                      <b>{{
                        row.usuario.data
                          ? row.usuario.data.attributes.nombre +
                            " " +
                            row.usuario.data.attributes.apellidos
                          : ""
                      }}</b></a
                    >
                  </template>
                </el-table-column> -->

                <el-table-column label="Acciones" align="left" :min-width="40">
                  <div slot-scope="{ row }" class="table-actions">
                    <base-button
                      outline
                      size="sm"
                      type="primary"
                      @click="viewTipo(row)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Ver</base-button
                    >
                    <base-button
                      v-if="row.usuario.data"
                      outline
                      size="sm"
                      type="danger"
                      @click="desAssignOnlyOnePost(row)"
                      style="padding-left: 10px; padding-right: 10px"
                      >Devolver</base-button
                    >

                    <!-- <el-tooltip content="Ver" placement="top">
                  <a
                    type="text"
                    @click="viewTipo(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-eye fa-lg"></i>
                  </a>
                </el-tooltip> -->
                    <!--     <el-tooltip content="Editar" placement="top">
                  <a
                    type="text"
                    @click="editTipo(row)"
                    class="table-action"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-edit fa-lg"></i>
                  </a>
                </el-tooltip> -->

                    <!--  <el-tooltip content="Eliminar" placement="top">
                  <a
                    type="text"
                    @click="deleteTipo(row.id)"
                    class="table-action table-action-delete"
                    data-toggle="tooltip"
                    style="cursor: pointer"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </el-tooltip> -->
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="row">
                <div class="col-xl-4">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>

                <div class="col-xl-8">
                  <p class="card-category" style="margin-top: 0.5rem">
                    Mostrando {{ total ? from + 1 : 0 }} - {{ to }} de
                    {{ total }} registros

                    <span v-if="selectedRows.length">
                      &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                    </span>
                  </p>
                </div>
              </div>

              <base-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </div>
        </card>

        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Mensajes recibidos</h3>
            </div>
          </div>

          <!-- TIMELINE -->
          <div class="pl-5 pt-2 pb-4" v-if="notificaciones.length > 0">
            <time-line type="one-side">
              <time-line-item
                :badge-type="
                  notif.tipo_notificacion.data.attributes.descripcion ==
                  'revision'
                    ? 'greenlight'
                    : notif.tipo_notificacion.data.attributes.descripcion ==
                      'sistema'
                    ? 'info'
                    : 'danger'
                "
                :badge-icon="
                  notif.tipo_notificacion.data.attributes.descripcion ==
                  'revision'
                    ? 'ni ni-settings'
                    : notif.tipo_notificacion.data.attributes.descripcion ==
                      'incidencia'
                    ? 'ni ni-ambulance'
                    : 'ni ni-send'
                "
                v-for="(notif, key, index) in notificaciones"
                :key="notif.id"
              >
                <badge
                  rounded
                  :type="
                    notif.tipo_notificacion.data.attributes.descripcion ==
                    'revision'
                      ? 'greenlight'
                      : notif.tipo_notificacion.data.attributes.descripcion ==
                        'sistema'
                      ? 'info'
                      : 'danger'
                  "
                  >{{
                    notif.tipo_notificacion.data.attributes.descripcion ==
                    "mensaje_directo"
                      ? "Mensaje directo"
                      : notif.tipo_notificacion.data.attributes.descripcion
                  }}</badge
                >
                <div class="mt-3">
                  <small class="text-muted font-weight-bold">
                    {{ moment(notif.createdAt).format("DD/MM/YYYY HH:mm") }}
                    ({{ moment(notif.createdAt).fromNow() }})
                  </small>
                  <h5 class="text-muted font-weight-bold">
                    Recibido de:
                    {{ notif.usuario_origen.data.attributes.nombre }}
                    {{ notif.usuario_origen.data.attributes.apellidos }}
                    <b>({{ notif.usuario_origen.data.attributes.email }})</b>
                  </h5>
                </div>

                <!--  MENSAJE DIRECTO -->
                <div
                  v-if="
                    notif.tipo_notificacion.data.attributes.descripcion ==
                    'mensaje_directo'
                  "
                >
                  <h5 class="mt-3 mb-0">{{ notif.descripcion }}</h5>
                  <br />
                </div>

                <!-- INCIDENCIA -->
                <div
                  v-if="
                    notif.tipo_notificacion.data.attributes.descripcion ==
                    'incidencia'
                  "
                >
                  <h5 class="mt-3 mb-0">{{ notif.descripcion }}</h5>
                  <br />
                  <h5 v-html="notif.activos"></h5>
                  <router-link
                    :to="notif.url"
                    class="dropdown-item text-center text-primary font-weight-bold py-3"
                    >Ver incidencia</router-link
                  >
                </div>
              </time-line-item>
            </time-line>
          </div>
          <div class="pl-5 pt-2 pb-4" v-else>
            <h5>
              No hay mensajes que mostrar. Aún no has recibido ningún mensaje.
            </h5>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import BaseButton from "@/components/BaseButton.vue";
import { BasePagination } from "@/components/";

import { TimeLine, TimeLineItem } from "@/components";
import Badge from "@/components/Badge";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import {
  Table,
  TableColumn,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  RadioButton,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work
import { cloneDeep } from "lodash";
moment.locale("es");

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import axios from "axios";

const EMPRESA_172 = 172;
const ESTADOS_ALBARAN_ASIGNADOS = ['asignado', 'entregado', 'pendiente_aceptar_devolucion'];

export default {
  layout: "DashboardLayout",
  components: {
    BaseInput,
    BaseButton,
    ValidationError,
    Loading,
    BasePagination,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,

    Badge,
    TimeLine,
    TimeLineItem,
  },
  mixins: [formMixin],

  data() {
    return {
      fullscreenLoading: false,
      loadingColor: "#7f1058",
      loadingBgColor: "#000",
      loadingHeight: 128,
      loadingWidth: 128,
      loadingTable: true,
      image: null,
      file: null,
      available_roles: [],
      user: {
        type: "users",
        username: null,
        email: null,
        nombre: null,
        apellidos: null,
        profile_image: null,
        imagen_perfil: null,
        activo: null,
        blocked: null,
        confirmed: null,
        cif: null,
        estado_usuario: null,
        telefono: null,
        /*  relationshipNames: ["roles"], */
        roles: [
          {
            type: "roles",
            id: null,
          },
        ],
      },
      query: null,
      activos: [],
      selectedRows: [],
      sort: "fecha_prox_revision",

      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [25, 50, 100],
      },
      multipleSelection: [],
      total: 0,
      loading: true,
      dialogFormVisible: false,
      dialogConfirmVisible: false,
      innerVisible: false,
      formLabelWidth: "120px",
      available_revisores: [],
      usuarioSeleccionado: null,
      fdesde: null,
      fhasta: null,
      estado: null,
      usuario: null,
      estados: ["Apto", "No apto", "Con incidencia", "Todos"],

      totalIncidencia: 0,
      totalCaducados: 0,
      totalCaducan: 0,
      totalAptos: 0,
      totalActivos: 0,
      notificaciones: [],
      configInput: {
        allowInput: true,
        dateFormat: "d-m-Y",
        locale: Spanish, // locale for this instance only
      },
    };
  },
  created() {
    this.get();
    this.getRoles();
  },
  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    plantaSelected() {
      return this.$plantaSelected;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },
  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    fdesde: {
      handler: "getListDebounced",
      immediate: true,
    },
    fhasta: {
      handler: "getListDebounced",
      immediate: true,
    },
    estado: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("users/get", id);

        this.user = this.$store.getters["users/user"];
        if (this.user.imagen_perfil) {
          this.image = this.user.imagen_perfil.url;
        }

        console.log(this.user);
        console.log(this.image);
        this.getListNotifications(this.user);
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    removeImage() {
      this.image = null;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async desAssignPost() {
      this.fullscreenLoading = true;
      for (const element of this.multipleSelection) {
        var el = element;
        el.usuario = null;
        await this.$store.dispatch("activos/update", el);
      }
      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success_devueltos");
    },

    async desAssignOnlyOnePost(el) {
      this.fullscreenLoading = true;

      el.usuario = null;
      await this.$store.dispatch("activos/update", el);

      this.dialogFormVisible = false;
      //this.dialogConfirmVisible = true;
      this.showSwal("success_devueltos");
    },

    async handleSubmit() {
      console.log("ENTRA");
      this.user.role = {
        disconnect: [],
        connect: [{ id: this.user.role.id, position: { end: true } }],
      };

      if (this.file) {
        console.log(this.file);
        await this.$store.dispatch("items/upload", {
          item: this.tipo,
          image: this.file,
        });

        this.user.imagen_perfil = await this.$store.getters["items/url"];

        console.log(this.user);
      }

      if (this.user.role) {
        try {
          await this.$store.dispatch("users/update", this.user);
          this.$notify({
            type: "success",
            message: "Usuario actualizado correctamente.",
          });
          this.goBack();
        } catch (error) {
          this.$notify({
            type: "danger",
            message: "Oops, ha habido un error",
          });
          console.log(error);
          console.log(error.response.data.errors);
          this.setApiValidation(error.response.data.error.details.errors);
        }
      }
    },

    async onSelectFile(e) {
      let files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;
      this.createImage(files[0]);
    },

    createImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
        this.file = file;
      };
      reader.readAsDataURL(file);
    },

    getRoles() {
      try {
        this.$store.dispatch("roles/list").then(() => {
          this.available_roles = cloneDeep(
            this.$store.getters["roles/dropdown"]
          );
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, ha habido un error",
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    /**
     * Para empresa 172: devuelve los IDs de activos que están en un albarán con estado
     * asignado, entregado o pendiente_aceptar_devolucion (y activo en empresa 172).
     * No filtra por usuario aquí; el listado de activos ya filtra por usuario + id $in.
     */
    async fetchActivoIdsEnAlbaranes172() {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || process.env.VUE_APP_API_URL || '';
      const url = `${baseUrl.replace(/\/$/, '')}/albaran-activo-materials`;
      const params = new URLSearchParams();
      ESTADOS_ALBARAN_ASIGNADOS.forEach((est, i) => {
        params.append(`filters[albaran_activo][estado][$in][${i}]`, est);
      });
      params.append('pagination[pageSize]', 1000);
      params.append('populate[activo]', 'true');
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${url}?${params.toString()}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const data = res.data?.data ?? res.data;
        const list = Array.isArray(data) ? data : [];
        const ids = new Set();
        list.forEach((m) => {
          const raw = m.attributes ?? m;
          const activo = raw.activo ?? m.activo;
          let aid = null;
          if (activo != null) {
            if (typeof activo === 'number') aid = activo;
            else if (activo.data != null) aid = activo.data.id ?? activo.data;
            else if (activo.id != null) aid = activo.id;
          }
          if (aid != null) ids.add(Number(aid));
        });
        return Array.from(ids);
      } catch (err) {
        console.error('Error fetchActivoIdsEnAlbaranes172:', err);
        return [];
      }
    },

    async getList() {
      var planta = localStorage.getItem("plantaSelected");

      const id = this.$route.params.id;
      console.log("usuario id: ", id);
      await this.$store.dispatch("profile/me");
      let profile = await this.$store.getters["profile/me"];
      console.log(profile);
      var empresas = [];
      profile.empresas.forEach((element) => {
        empresas.push(element.id);
      });

      if (planta != 0) {
        empresas = [planta];
      }

      if (this.sort.includes("data.attributes.")) {
        this.sort = this.sort.replace("data.attributes.", "");
      }

      var filters = {
        $and: [
          {
            empresa: {
              id: { $in: empresas },
            },
            usuario: {
              id: { $in: id },
            },
          },
          { $or: [] },
        ],
      };

      // Empresa 172: solo activos que estén en albaranes con estado ASIGNADO, ENTREGADO o PENDIENTE_ACEPTAR_DEVOLUCIÓN
      const empresasIncluye172 = empresas.some((e) => Number(e) === EMPRESA_172);
      if (empresasIncluye172) {
        const activoIdsEnAlbaran = await this.fetchActivoIdsEnAlbaranes172();
        if (activoIdsEnAlbaran.length > 0) {
          filters.$and.push({ id: { $in: activoIdsEnAlbaran } });
        }
        // Si la API no devolvió IDs (ej. filtros no soportados), no añadimos filtro id y se muestran todos los activos del usuario en 172
      }

      if (this.query) {
        console.log(filters["$and"][1]["$or"]);

        filters["$and"][1]["$or"].push(
          {
            subtipo: {
              nombre: { $containsi: this.query },
            },
          },
          {
            fabricante: {
              nombre: { $containsi: this.query },
            },
          },
          {
            modelo: {
              nombre: { $containsi: this.query },
            },
          },
          {
            numero_serie: { $containsi: this.query },
          },
          {
            usuario: {
              username: { $containsi: this.query },
            },
          },
          {
            usuario: {
              nombre: { $containsi: this.query },
            },
          },
          {
            usuario: {
              apellidos: { $containsi: this.query },
            },
          }
        );
      }

      if (this.fdesde) {
        var newdate = this.fdesde.split("-").reverse().join("-");
        filters["$and"].push({
          fecha_prox_revision: { $gt: newdate },
        });
      }

      if (this.fhasta) {
        var newdate = this.fhasta.split("-").reverse().join("-");
        filters["$and"].push({
          fecha_prox_revision: { $lt: newdate },
        });
      }

      if (this.estado) {
        if (this.estado == "Apto") {
          filters["$and"].push({
            fecha_prox_revision: { $gte: new Date().getTime() },
          });
        } else if (this.estado == "No apto") {
          filters["$and"].push({
            fecha_prox_revision: { $lte: new Date().getTime() },
          });
        } else if (this.estado == "Con incidencia") {
          filters["$and"].push({
            incidencias: {
              estado_incidencia: {
                descripcion: { $eq: "abierta" },
              },
            },
          });
        }
      }

      let params = {
        ...(this.sort ? { sort: this.sort } : {}),

        filters: filters,
        pagination: {
          page: this.pagination.currentPage,
          pageSize: this.pagination.perPage,
        },
      };
      await this.$store.dispatch("activos/list", params).then(() => {
        this.activos = this.$store.getters["activos/list"];
        console.log(this.activos);
        this.total = this.$store.getters["activos/listTotal"];
        if (this.total > this.totalActivos) {
          this.totalActivos = this.total;
        }
      });

      this.loading = false;
    },
    addTipo() {
      this.$router.push({
        name: "Add notificacion to user",
        params: { id: this.user.id },
      });
    },

    viewTipo(row) {
      console.log(row);
      this.$router.push({
        name: "View Activo",
        params: { id: row.id },
      });
    },
    editTipo(row) {
      console.log(row);
      this.$router.push({
        name: "Edit Activo",
        params: { id: row.id },
      });
    },
    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `${prop}:desc`;
      } else {
        this.sort = `${prop}:asc`;
      }
      this.getList();
    },
    showSwal(type) {
      if (type === "basic") {
        swal.fire({
          title: `Here's a message!`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary",
        });
      } else if (type === "info") {
        swal.fire({
          icon: "info",
          title: `Info`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info",
        });
      } else if (type === "success") {
        this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipos asignados con éxito!`,
            // text: 'Equipos entregados con éxito',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "success_devueltos") {
        this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipos devueltos con éxito!`,
            text: "Los equipos quedan disponibles para asignarlos a otro usuario.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "warning") {
        swal.fire({
          title: `Warning`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning",
          icon: "warning",
        });
      } else if (type === "question") {
        swal.fire({
          title: `Are you sure?`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "question",
        });
      }
    },
    async getListNotifications(user) {
      const usuario = user;
      console.log("USUARIOOOOOO: ", usuario);

      var filters = {
        $and: [
          {
            usuario_destinos: {
              id: { $in: usuario.id },
            },
          },
          { $or: [] },
        ],
      };

      let params = {
        filters: filters,
      };

      await this.$store.dispatch("notificaciones/list", params).then(() => {
        this.notificaciones = this.$store.getters["notificaciones/list"];

        console.log("NOTIFICACIONES:");
        console.log(this.notificaciones);
      });

      this.loading = false;
      this.loadingTable = false;
    },
  },
};
</script>
